import { render } from "./InfraCompetencyCard.vue?vue&type=template&id=42bbf1da&scoped=true&ts=true"
import script from "./InfraCompetencyCard.vue?vue&type=script&lang=ts"
export * from "./InfraCompetencyCard.vue?vue&type=script&lang=ts"

import "./InfraCompetencyCard.vue?vue&type=style&index=0&id=42bbf1da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bbf1da"]])

export default __exports__